var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audiointro"},[_c('button',{staticClass:"skip",on:{"click":_vm.skipAudio}}),_c('canvas',{ref:"oscilloscope"})])}
var staticRenderFns = []

export { render, staticRenderFns }